module.exports = __webpack_public_path__ + "static/media/OneSmartSheep.504de9a3.jpg";